import PropTypes from 'prop-types';
import React from 'react';
import TitleDetailDrawer from '../Title/TitleDetailDrawer';

export default class ReviewHeaderTitleBlurb extends React.Component {
	static propTypes = {
		review: PropTypes.object,
	};

	render() {
		const { product } = this.props.review;
		const { communityId } = this.props;
		return (
			<div>
				<div>
					<div className="bold title-detail-name dotDot acc-font">
						<TitleDetailDrawer
							sku={product.sku}
							communityId={communityId}>
							{product ? product.name : <div />}
						</TitleDetailDrawer>
					</div>
					<div>{product && product.author}</div>
					<div className="dotDot">
						{product ? (
							<div>
								{product.ean}&nbsp;&bull;&nbsp;
								{product.sku}
								&nbsp;&bull;&nbsp;
								{product.formatDescription}
							</div>
						) : (
							<div />
						)}
					</div>
					<div className="dotDot" style={{ maxWidth: 350 }}>
						{product ? (
							<div>
								{new Date(product.pubDate).toLocaleDateString(
									'en-US',
									{
										year: 'numeric',
										month: 'long',
										day: 'numeric',
									},
								)}
								&nbsp;&bull;&nbsp;{product.supplier}
							</div>
						) : (
							<div />
						)}
					</div>
				</div>
			</div>
		);
	}
}
